module.exports = __webpack_public_path__ + "img/oufu_100x125x12b.prt.f37e43ba.jpg";